module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/notokr-bold.woff2
// module id = L3Pg
// module chunks = 0